<template>
  <section class="experience-wrapper--slider">
    <LazyHydrate never :trigger-hydration="lazy.hydration">
      <div class="el-container">
        <el-row :gutter="4">
          <el-col :xs="15" :sm="16">
            <h2 v-if="exExperience.duration" class="experience-headline">{{
              description
            }}</h2>
            <h1 class="experience--name">{{ exExperience.name }}</h1>

            <LadPriceExperienceCustom v-if="showBtnDates" />

            <!-- Estos botones solo son para mobile -->
            <template v-if="exExperience.is_lad">
              <el-button
                v-if="hasAvailability"
                v-scroll-to="{
                  el: '.lad-landing-availability__custom',
                  offset: -120,
                }"
                class="cta-book-mobile"
                >{{ $t(`general.landings.see_dates`) }}</el-button
              >
              <el-button v-else class="cta-book-mobile" @click="handleScroll">{{
                $t('route.i_want_to_quote')
              }}</el-button>
            </template>
            <!-- Estos botones solo son para mobile -->

            <el-button
              v-if="hasRecommendedAvailability"
              v-scroll-to="{
                el: '#experience-wrapper--main-availability',
                offset: -120,
              }"
              class="cta-book"
              >{{ $t(`${base}.book_this_experience`) }}</el-button
            >

            <el-button
              v-else-if="showBtnDates"
              class="cta-book"
              @click="openModal"
              >{{ $t(`${base}.book_this_experience`) }}</el-button
            >

            <el-button v-else class="cta-book" @click="handleScroll">{{
              $t('route.i_want_to_quote')
            }}</el-button>
          </el-col>

          <el-col :xs="9" :sm="8">
            <div
              class="container-image-cover"
              :class="{ 'has-duration': exExperience.duration }"
              @click="handleOpenDialog"
            >
              <LadCoverImage
                :max-width="400"
                :min-height="400"
                :include-all-sources="true"
                :lazy-loading="false"
                :preloading="true"
                :cover="cover"
                :title="exExperience.name"
              />

              <el-button
                v-if="showGallery || showVideo"
                class="cta-camera"
                @click="handleOpenDialog"
              >
                <i class="fas fa-camera"></i>
              </el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </LazyHydrate>

    <LadExperienceGallery
      v-if="dialog.gallery"
      :open="dialog.gallery"
      :with-main-image="false"
      @close="handleCloseDialog"
    />

    <LazyHydrate never :trigger-hydration="dialog.video">
      <LadVideoDialog
        :open="dialog.video"
        :src="video"
        @close="handleCloseDialog"
      />
    </LazyHydrate>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import GenericEventMixin from '@/utils/mixin/generic-event'
import { LadVideoDialog } from '@/components/pages/landing/video'
import LadPriceExperienceCustom from './price'

export default {
  name: 'LadSlider',
  components: {
    LadPriceExperienceCustom,
    LadCoverImage: () =>
      import(
        /* webpackChunkName: "lad-cover-image" */ '@/components/cover/image'
      ),
    LadExperienceGallery: () =>
      import(
        /* webpackChunkName: "lad-experience-gallery" */ '@/components/experience-gallery'
      ),
    LadVideoDialog,
  },
  mixins: [GenericEventMixin],
  props: {
    // eslint-disable-next-line vue/no-boolean-default
    showGallery: { type: Boolean, default: true },
    showVideo: { type: Boolean, default: false },
    cover: { type: String, default: null },
  },
  data() {
    return {
      base: 'experience.slider',
      symbol: '$',
      dialog: {
        gallery: false,
        video: false,
      },
      lazy: {
        hydration: false,
      },
    }
  },
  computed: {
    ...mapGetters('device', ['isMobile']),
    ...mapState('experience', {
      promotions: 'promotions',
      exExperience: 'experience',
      totalAmount: (state) => parseFloat(state.sales_plan.total_amount),
    }),
    ...mapState('settings', ['currency']),
    ...mapState('availability', {
      hasAvailability: (state) => state.exist,
      withAvailability: (state) => state.availability.ranges.length > 0,
      hasRecommendedAvailability: (state) => state.hasRecommendedAvailability,
    }),
    video() {
      const common = `${process.env.DO_SPACES_CDN_ENDPOINT}/web-client/videos/landing-peru.{type}`

      return {
        mp4: common.replace('{type}', 'mp4'),
        webm: common.replace('{type}', 'webm'),
        ogg: common.replace('{type}', 'ogg'),
      }
    },
    countries() {
      return this.exExperience.starting_point_country !==
        this.exExperience.ending_point_country
        ? `${this.exExperience.starting_point_country}, ${this.exExperience.ending_point_country}`
        : `${this.exExperience.starting_point_country}`
    },
    description() {
      return this.$tc(`${this.base}.h2_days`, this.exExperience.duration, {
        days: this.exExperience.duration,
      })
    },
    showBtnDates() {
      return (
        this.totalAmount > 0 && (this.hasAvailability || this.withAvailability)
      )
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const timer = setTimeout(() => {
        clearTimeout(timer)

        this.lazy.hydration = true
      }, 1000)
    },
    handleOpenDialog() {
      if (this.showGallery || this.showVideo) {
        this.dialog = {
          gallery: this.showGallery,
          video: this.showVideo,
        }
      }
    },
    handleCloseDialog() {
      this.dialog = {
        gallery: false,
        video: false,
      }
    },
    handleScroll() {
      this.$scrollTo('.experience-wrapper--container-contact-us')
    },
    async openModal() {
      await this.$store.dispatch('modals/toggle', 'availability')
    },
  },
}
</script>

<style lang="scss">
.experience-wrapper--slider {
  padding: 20px 0 0;

  @media (min-width: 768px) {
    padding: 40px 0;
  }

  .wrapper-show-video {
    display: inline-block;
    text-align: center;

    .play-video {
      font-size: 7em;
      color: white;
      cursor: pointer;
    }

    h4 {
      color: white;
      text-transform: uppercase;
      font-size: 2em;
      font-weight: 300;
      margin: 10px 0;
      text-shadow: 2px 2px 15px #464646;
    }

    @media screen and (min-width: 700px) {
      padding: 0 50px;
      margin: 0 0 0 auto;
    }
  }

  .el-container {
    padding: 0 20px;
    .el-row {
      width: 100%;
    }

    .experience-headline {
      color: #666;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 36.6px; /* 203.333% */
      margin: 0;

      @media (min-width: 768px) {
        font-size: 21.7px;
      }
    }

    .experience--name {
      color: #221f20;
      font-size: 32px;
      font-style: normal;
      font-weight: 700;
      line-height: 38.4px; /* 38.4px */
      margin: 0;

      @media (min-width: 768px) {
        font-size: 56px;
        line-height: 73.82px; /* 131.821% */
      }
    }

    .price-wrapper--custom {
      padding: 30px 0;
      width: max-content;
      max-width: 90vw;

      @media (min-width: 768px) {
        width: unset;
        max-width: unset;
      }
    }

    .cta-book {
      background: #1aa31c;
      border-radius: 3px;
      color: #fff;
      text-align: center;
      font-size: 19px;
      font-style: normal;
      font-weight: 500;
      line-height: 14px;
      padding: 21px 40px;
      display: none;

      @media (min-width: 768px) {
        display: block;
      }
    }

    .cta-book-mobile {
      background: #1aa31c;
      border-radius: 3px;
      color: #fff;
      text-align: center;
      font-size: 19px;
      font-style: normal;
      font-weight: 500;
      line-height: 14px;
      padding: 20px 40px;

      @media (min-width: 768px) {
        display: none;
      }
    }

    .container-image-cover {
      position: relative;
      max-width: 350px;
      border-radius: 50%;
      cursor: pointer;

      &.has-duration {
        margin-top: 40px;

        @media (min-width: 768px) {
          margin-top: 0;
        }
      }

      .lad-image {
        &.image--cover {
          img {
            aspect-ratio: 1;
            border-radius: 50%;
          }
        }
      }

      .cta-camera {
        position: absolute;
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
        border-radius: 50%;
        aspect-ratio: 1;
        padding: 8px;

        @media (min-width: 768px) {
          padding: 10px 20px;
        }

        i {
          color: black;
          font-size: 22px;

          @media (min-width: 768px) {
            font-size: 38px;
          }
        }
      }
    }
  }
}
</style>
